export const setDiagramHighlight =
  (selection?: go.Set<go.Part>) => (diagram: go.Diagram) => {
    if (selection && selection.size) {
      diagram.highlightCollection(selection);
    } else {
      diagram.clearHighlighteds();
    }
  };
